import { isEmpty } from "../../config/funcs"

export const loginValidation = (data) => {
    let error = {}
    if(isEmpty(data.username)) error.username = "REQUIRED"
    if(isEmpty(data.password)) error.password = "REQUIRED"

    return error
}